class CartIcon extends HTMLElement {
    constructor() {
      super();
  
      this.cartDrawer = document.querySelector('cart-drawer');
      // this.header = document.querySelector('sticky-header');
      // this.onBodyClick = this.handleBodyClick.bind(this);
      // this.onBodyClick = this.onBodyClick.bind(this);
      // this.addEventListener('keyup', event => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.addEventListener('click', this.onCartIconClick.bind(this));

      // this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      //   closeButton.addEventListener('click', this.close.bind(this))
      // );
      if (this.hasOpenSearchParam()) {
        window.addEventListener('DOMContentLoaded', () => {
          this.open();
        });
      }

    }

    onCartIconClick(event) {
      event.preventDefault();
      this.hasAttribute('show-cart') ? this.close() : this.open();
    }

    isActive() {
      return this.hasAttribute('show-cart');
    }
  
    open() {
      this.setAttribute('show-cart', true);
      // document.body.addEventListener('click', this.onBodyClick);
      // document.body.classList.add('overflow-hidden');
      document.body.classList.add('cart-drawer--open');
      document.disablePageScroll();
      this.cartDrawer.open();
      // this.notification.classList.add('animate', 'active');
      // this.notification.addEventListener('transitionend', () => {
      //   this.notification.focus();
      //   trapFocus(this.notification);
      // }, { once: true });
      // document.body.addEventListener('click', this.onBodyClick);
    }
  
    close() {
      // this.notification.classList.remove('active');
      this.removeAttribute('show-cart');
      // document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('cart-drawer--open');
      document.enablePageScroll();
      // document.body.removeEventListener('click', this.onBodyClick);
      // removeTrapFocus(this.activeElement);
    }

    hasOpenSearchParam() {
      return /cart=open/.test(location.search);
    }
    
    /*
    onBodyClick(event) {
      const target = event.target;
      if (target !== this && !target.closest('cart-icon')) {
        // const disclosure = target.closest('details-disclosure');
        // this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }
    */
    
    /*
    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
        if (this.header) this.header.reveal();
        this.open();
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `#cart-notification-product-${this.productId}`,
        },
        {
          id: 'cart-notification-button'
        },
        {
          id: 'cart-icon'
        }
      ];
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
    */

}
  
customElements.define('cart-icon', CartIcon);
  